module.exports = __webpack_public_path__ + "img/statue-of-liberty.d7919614.jpg";